export default __webpack_public_path__ + "static/media/ev-wall-cable-black.b9a3d381.jpg";